import { Grid, Link, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  width: "100%",
  maxWidth: "1200px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const LinkWrapper = styling(Link)({
  textDecoration: "none",
  color: "#000",
  width: "100%",
});

export const Wrapper = styling("div")({
  borderRadius: "0.625rem",
  boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.15s ease-in-out",
  overflow: "clip",

  ":hover": {
    cursor: "pointer",
    boxShadow: "0 0 0 2px rgba(0,0,0,0.35)",
  },
});

export const AdviceImageBanner = styling("img")({
  width: "100%",
  height: "240px",
  objectFit: "cover",
});

export const AdviceDetailsContainer = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  padding: "1rem 1rem",
  flex: 1,
  background: "#FFF",
});

export const AdviceTitle = styling("h2")({
  color: "rgba(0, 0, 0, 0.8)",
  fontWeight: "700",
  fontSize: "1rem",
  lineHeight: "24px",
  margin: "0",
});

export const AdviceExcerpt = styling("h3")({
  color: "#000",

  fontWeight: "500",
  fontSize: "0.875rem",
  lineHeight: "20px",

  margin: "0",

  "& p": {
    margin: "0",
  },
});

export const GridTopicCardsContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "3rem",
  maxWidth: "1200px",

  "@media (max-width: 1279px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },

  "@media (max-width: 640px)": {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
});
